import React from "react";
import SegmentedToggle from "../../../library/SegmentedToggle";

/**
 * "Study Phases | Re-arrange" segmented toggle (SPEC1 R1).
 * @param {"table"|"re-arrange"} props.mode Current query-string `type` value.
 * @param {(mode: "table"|"re-arrange") => void} props.onChange
 * @param {boolean} [props.rearrangeDisabled] Disables the Re-arrange option, e.g. when there are no phases to reorder yet.
 * @param {string} [props.rearrangeDisabledReason] Tooltip shown while the Re-arrange option is disabled.
 */
function StudyPhasesToggle({ mode, onChange, rearrangeDisabled = false, rearrangeDisabledReason }) {
    return (
        <SegmentedToggle
            ariaLabel="Study phases view"
            value={mode}
            onChange={onChange}
            options={[
                { value: "table", label: "Study Phases" },
                { value: "re-arrange", label: "Re-arrange", disabled: rearrangeDisabled, disabledReason: rearrangeDisabledReason },
            ]}
        />
    );
}

StudyPhasesToggle.displayName = "StudyPhasesToggle";

export default StudyPhasesToggle;
